import script from "./GPTInlineBanner320Slot2.vue?vue&type=script&setup=true&lang=js"
export * from "./GPTInlineBanner320Slot2.vue?vue&type=script&setup=true&lang=js"

import "./GPTInlineBanner320Slot2.vue?vue&type=style&index=0&id=998788d4&lang=css"

const __exports__ = script;

export default __exports__